(() => {
  document.querySelectorAll('.fsl').forEach((root) => {
    const reels = [...root.querySelectorAll('.fsl-reel')];
    const videoOf = (reel) => reel.querySelector('video');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Autoplay muted reels only while they're on screen.
    if ('IntersectionObserver' in window && !reduceMotion) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach(({ target, isIntersecting }) => {
            const v = videoOf(target);
            if (!v) return;
            if (isIntersecting) v.play().catch(() => {});
            else v.pause();
          });
        },
        { threshold: 0.6 }
      );
      reels.forEach((r) => io.observe(r));
    }

    // Tap a reel (or its speaker button) to turn sound on; only one plays with sound.
    const toggle = (reel) => {
      const v = videoOf(reel);
      if (!v) return;
      const turnOn = v.muted;
      reels.forEach((r) => {
        const other = videoOf(r);
        if (other && r !== reel) other.muted = true;
        r.classList.remove('is-unmuted');
        r.querySelector('[data-fsl-sound]')?.setAttribute('aria-label', 'Turn sound on');
      });
      v.muted = !turnOn;
      if (turnOn) {
        v.play().catch(() => {});
        reel.classList.add('is-unmuted');
        reel.querySelector('[data-fsl-sound]')?.setAttribute('aria-label', 'Turn sound off');
      }
    };
    reels.forEach((reel) => reel.addEventListener('click', () => toggle(reel)));

    // Show the sticky checkout bar once the hero's button scrolls away.
    const sticky = root.querySelector('[data-fsl-sticky]');
    const heroCta = root.querySelector('.fsl-hero [data-fsl-cta]');
    const finalCta = root.querySelector('.fsl-final [data-fsl-cta]');
    if (sticky && heroCta && 'IntersectionObserver' in window) {
      const seen = new Map();
      const so = new IntersectionObserver((entries) => {
        entries.forEach((e) => seen.set(e.target, e.isIntersecting));
        const heroVisible = seen.get(heroCta);
        const finalVisible = finalCta && seen.get(finalCta);
        sticky.classList.toggle('is-visible', !heroVisible && !finalVisible);
      });
      so.observe(heroCta);
      if (finalCta) so.observe(finalCta);
    }
  });
})();
